import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { TransactionTypeEnum } from '../../shared/transaction/dto/transaction-type.enum';
import { AccountingPackageService } from '../../shared/accounting-package/accounting-package.service';
import { PostTransactionsSearchDto } from '../../shared/dto/post-transactions-search.dto';
import { PagedResultGeneric } from 'src/app/shared';
import { SelectItem } from 'primeng/api';
import { FinancialServiceService } from '../../shared/financial.service';
import { AccountingPackageTypeEnum } from 'src/app/revenue/shared/accounting-package/accounting-package-type.enum';
@Component({
  selector: 'wl-post-transactions-request-search',
  templateUrl: './post-transactions-request-search.component.html',
  styleUrls: ['./post-transactions-request-search.component.less'],
    standalone: false
})
export class PostTransactionsRequestSearchComponent implements OnInit {
  @Input() searchParams: PostTransactionsSearchDto; // = new EventEmitter<PostTransactionsSearchDto>();
  @Output() selectedAccountingPackageId = new EventEmitter<number>();
  @Output() displayPackageWarning = new EventEmitter();

  transactionTypes: SelectItem[] = [
    { label: 'Adjustments', value: 'Adjustment' },
    { label: 'Invoice Line Item', value: 'Invoice Line Item' },
    { label: 'Payments', value: 'Invoice Payment' },
    { label: 'Unapplied Payments', value: 'Unapplied Payment' },
  ];

  tranCodeSearchResult: Array<string> = [];

  tranCodes: Array<string> = [];

  accountingPackages: SelectItem[] = [];
  fullAccountingPackages: object;
  displayWarning: boolean;
  selectedAccountingPackageName: string;
  selectedPackageTypeName: string;
  private _searchParams: PostTransactionsSearchDto;

  constructor(private _accountingPackageService: AccountingPackageService, private _financialService: FinancialServiceService) {
    this.searchParams = { TranCodes: [], AccountingPackageID: 0 } as PostTransactionsSearchDto;
    this.displayWarning = false;
  }

  ngOnInit(): void {
    this._accountingPackageService.getAccountingPackages().then((packages) => {
      this.accountingPackages = packages.map<SelectItem>((x) => {
        return { label: x.Name, value: x.AccountingPackageId };
      });
      this.fullAccountingPackages = packages;
      if (this.accountingPackages.length != 0) {
        this.searchParams.AccountingPackageID = this.accountingPackages[0].value;
      }
      this.invalidAccountingPackageSelected();
    });

    this._financialService.getAllTranCodes().then((data) => {
      this.tranCodes = data;
    });
  }
  searchTranCodes(event: any) {
    this.tranCodeSearchResult = this.tranCodes.filter((x) => x.toLowerCase().includes(event.query.toLowerCase()));
  }

  fetchResults(): Promise<PagedResultGeneric<PostTransactionsSearchDto>> {
    return this._financialService.searchUnpostedTransactions(this.searchParams);
  }

  accountingPackageChanged() {
    this.selectedAccountingPackageId.emit(this.searchParams.AccountingPackageID);
  }

  invalidAccountingPackageSelected() {
    for (var packageType in this.fullAccountingPackages) {
      if (this.fullAccountingPackages[packageType].AccountingPackageId == this.searchParams.AccountingPackageID) {
        var selectedItem = this.fullAccountingPackages[packageType];
        if (
          (selectedItem.PackageType == AccountingPackageTypeEnum.Quickbooks && selectedItem.AutoSyncBatch == 1) ||
          (selectedItem.PackageType == AccountingPackageTypeEnum.MicrosoftDynamicsGP && selectedItem.AutoSyncBatch == 1) ||
          (selectedItem.PackageType == AccountingPackageTypeEnum.Intacct && selectedItem.AutoSyncBatch == 1)
        ) {
          this.displayWarning = true;
          this.selectedAccountingPackageName = selectedItem.Name;
          switch (selectedItem.PackageType) {
            case AccountingPackageTypeEnum.Intacct:
              this.selectedPackageTypeName = 'Intacct';
              break;
            case AccountingPackageTypeEnum.MicrosoftDynamicsGP:
              this.selectedPackageTypeName = 'Microsoft Dynamics GP';
              break;
            case AccountingPackageTypeEnum.Quickbooks:
              this.selectedPackageTypeName = 'Quickbooks Desktop';
              break;
            case AccountingPackageTypeEnum.QuickbooksOnline:
              this.selectedPackageTypeName = 'Quickbooks Online';
              break;
            case AccountingPackageTypeEnum.None:
            default:
              this.selectedPackageTypeName = 'None';
              break;
          }
          this.displayPackageWarning.emit(true);
        } else {
          this.displayWarning = false;
          this.displayPackageWarning.emit(false);
        }
      }
    }
  }
}
